module.exports = __webpack_public_path__ + "img/511028589.afe05be2.svg";